
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricMotorDc as ObiElectricMotorDcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-motor-dc.js';
 
 
 

 
 export const ObiElectricMotorDc = createComponent({
   react: React,
   tagName: 'obi-electric-motor-dc',
   elementClass: ObiElectricMotorDcElement,
   events: {
     
   }
  });
 
 